/**
 * The four things a parent scanning the page should retain. All drawn from the resumé —
 * "13+ years" is 2010–2023, "6" counts Oxford Academy, Kids R' Kids, Primrose School and
 * three nanny households.
 */
export type Credential = {
  /** Set for stats that should count up on reveal. */
  value?: number;
  /** Rendered after the counted value, e.g. the "+" in "13+". */
  suffix?: string;
  /** Used instead of value/suffix for non-numeric credentials. */
  label?: string;
  caption: string;
};

export const credentials: Credential[] = [
  { value: 13, suffix: '+', caption: 'years caring for children' },
  { value: 6, caption: 'families & schools' },
  { label: 'CPR & First Aid', caption: 'certified' },
  { label: 'Fire Safety', caption: 'certified' },
];

export type Strength = {
  emoji: string;
  title: string;
  body: string;
};

export const strengths: Strength[] = [
  {
    emoji: '🍼',
    title: 'Infant care & daily rhythm',
    body:
      'Feedings, changing, naps and a routine that holds together — including two sets of infants' +
      ' looked after from their first weeks right up to preschool.',
  },
  {
    emoji: '🎨',
    title: 'Real early learning',
    body:
      'Years as a lead teacher implementing curriculum for ages zero to five, so play has' +
      ' something behind it and the day goes somewhere.',
  },
  {
    emoji: '💚',
    title: 'Families who stay in touch',
    body:
      'The family whose newborn I nannied still calls me for babysitting years later. That is' +
      ' the part of this work I am proudest of.',
  },
];
